import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { cn } from '../lib/utils'

interface ImageProps {
  component: Component
  locale: LocaleCode
  style: React.CSSProperties
}

export function Image({ component, locale, style }: ImageProps) {
  const config = component.config as any
  const src = config.src
  const alt = getLocalizedText(config.alt, locale)
  const objectFit = config.objectFit || 'cover'

  const objectFitMap = {
    cover: 'object-cover',
    contain: 'object-contain',
    fill: 'object-fill',
    none: 'object-none',
    'scale-down': 'object-scale-down',
  }
  const objectFitClass = objectFitMap[objectFit as keyof typeof objectFitMap] || 'object-cover'

  return (
    <img
      src={src}
      alt={alt}
      style={{
        ...style,
        width: style.width || undefined,
        height: style.height || undefined,
      }}
      className={cn(
        !style.width && 'w-full',
        !style.height && 'h-auto',
        objectFitClass
      )}
    />
  )
}
